import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["align", "alignSelf", "className", "children", "columnType", "expands", "overflow"];
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import cx from 'classnames';
import { ALIGN_PROPS, COLUMN_TYPES } from '../UIColumnConstants.ts';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  align: PropTypes.oneOf(ALIGN_PROPS),
  alignSelf: PropTypes.oneOf(ALIGN_PROPS),
  columnType: PropTypes.oneOf(COLUMN_TYPES).isRequired,
  expands: PropTypes.bool,
  overflow: PropTypes.bool,
  children: PropTypes.node
};
const WrapperColumnStyles = css(["display:inline-flex;justify-content:space-between;width:100%;word-break:break-word;overflow:visible;"]);
const SpreadsColumnStyles = css(["display:flex;flex-direction:column;flex-shrink:100000;width:100%;overflow-x:auto;overflow-y:hidden;white-space:normal;&.expand{flex-grow:1;}&.overflowVisible{overflow:visible;}"]);
const ContentColumnStyles = css(["display:flex;flex-wrap:nowrap;flex-shrink:1;.UIColumn-content > &{flex-shrink:0;}"]);
const ColumnWrapper = styled.div.withConfig({
  displayName: "UIAbstractColumn__ColumnWrapper",
  componentId: "qav4ut-0"
})(["", ""], ({
  columnType
}) => {
  if (columnType === 'wrapper') return WrapperColumnStyles;
  if (columnType === 'spreads') return SpreadsColumnStyles;
  return ContentColumnStyles;
});
export default function UIAbstractColumn(_ref) {
  let {
      align,
      alignSelf,
      className,
      children,
      columnType,
      expands,
      overflow
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const computedClassName = cx(className, align && `align-${align}`, alignSelf && `align-self-${alignSelf}`, columnType && `UIColumn-${columnType}`, overflow && "overflowVisible", expands && "expands");
  return /*#__PURE__*/_jsx(ColumnWrapper, Object.assign({}, rest, {
    columnType: columnType,
    className: computedClassName,
    children: children
  }));
}
UIAbstractColumn.propTypes = propTypes;
UIAbstractColumn.displayName = 'UIAbstractColumn';